import React, { useState, useEffect, useCallback } from "react";
import { Auth } from "aws-amplify";
import { jwtDecode } from "jwt-decode";
import { useLoading } from "../../../context/LoadingContext";
import { useNavigate } from "react-router-dom";
import DataTable from "../../Requirement/components/common/ReusableTable";
import SearchFilter from "../../Requirement/components/common/SearchFilter";
import {
  fetchData,
  postQuery,
  searchfetchQueries,
} from "../../Requirement/services/RequirementServices";
import OfferDetails from "../requirement/component/OfferDetails";
import RFQForm from "./components/RFQForm";
// import RFQDetailsReadOnly from "./components/RFQDetailsReadOnly";
import { Box, Tabs, Tab } from "@mui/material";
import AlertModal from "../../Requirement/components/common/AlerModel";
import TrustScoreModal from "../../../components/common/TrustScoreModal";

const NegotiateOffers = ({ requirementDetails }) => {
  const navigate = useNavigate();
  const { setLoading, loading } = useLoading();
  const [activeUser, setActiveUser] = useState("");
  const [offerList, setOfferList] = useState([]);
  const [selectedRFQ, setSelectedRFQ] = useState(null);
  const [referenceOffers, setReferenceOffers] = useState([]);
  const [rowStart, setRowStart] = useState(0);
  const [pageSize] = useState(5);
  const [totalItems, setTotalItems] = useState(0);
  const [selectedOffer, setSelectedOffer] = useState(null);
  const [error, setError] = useState(null);
  const [INRToUsd] = useState(0.012);
  const [rfqDetailsTabValue, setRfqDetailsTabValue] = useState(0);
  const [searchValues, setSearchValues] = useState({
    rfqNumber: "",
    deliveryDate: "",
    rfqDate: "",
    status: "",
  });

  const [modal, setModal] = useState({
    show: false,
    type: "info",
    title: "",
    message: "",
    autoClose: false,
    isConfirm: false,
    onConfirm: null,
  });
  const handleModalClose = () => {
    const action = modal.nextAction;
    setModal((prev) => ({ ...prev, show: false, nextAction: null }));
    if (action) action();
  };

  // State for Verification Status Modal
  const [trustModal, setTrustModal] = useState(false);

  const trustModel = useCallback(() => {
    setTrustModal(true);
  }, []);

  const [productList, setProductList] = useState([]);
  const [productGradeList, setProductGradeList] = useState([]);
  const [allProductMaster, setAllProductMaster] = useState([]);
  const [buyerInfo, setBuyerInfo] = useState([]);
  const [referenceOfferSelected, setReferenceOfferSelected] = useState(null);

  const [firmOfferModal, setFirmOfferModal] = useState({
    show: false,
    offer: null,
    remarks: "",
  });

  const [tabValue, setTabValue] = useState(0);
  const TabPanel = ({ children, value, index }) => {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };

  const handleTabChange = useCallback((event, newValue) => {
    setTabValue(newValue);
  }, []);

  const NegotiatedOffers = useCallback(
    async (newRowStart = rowStart) => {
      setLoading(true);
      setError(null);
      try {
        const body = {
          target: "listBuyerExtendedRequirementsItems",
          rowStart: newRowStart,
          pageSize: pageSize,
          filterTerms: {
            CategoryType: "rfq",
            //OfferStatusExtended: "Firmoffer",
            orOfferStatusExtended: ["Firmoffer", "BAFO"],
            ReferenceOfferNull: "''",
            BuyerEmailID: activeUser,
            Deleted: 0, // Only fetch non-deleted items
          },
        };

        const response = await fetchData(body);
        if (Array.isArray(response.items) || Array.isArray(response)) {
          setOfferList(response.items || response || []);
          setTotalItems(response.total || 0);
        } else {
          throw new Error("Unexpected response format");
        }
      } catch (error) {
        console.error("Error loading matching offers:", error);
        setError("Failed to load matching offers. Please try again.");
        setOfferList([]);
        setTotalItems(0);
      } finally {
        setLoading(false);
      }
    },
    [rowStart, pageSize, setLoading, activeUser]
  );

  const getRequirementDetails = useCallback(async (requirementsID) => {
    try {
      const response = await fetchData({
        target: "listRequirements",
        userOrder: "RequirementsID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { RequirementsID: requirementsID },
      });

      if (response.items && response.items.length > 0) {
        const rfq = response.items[0];

        setSelectedRFQ(rfq);
      }
    } catch (error) {
      console.error("Error fetching requirement details:", error);
      setSelectedRFQ(null);
    }
  }, []);

  const getReferenceOffers = useCallback(
    async (rowSelected) => {
      setReferenceOffers([]); // Clear previous offers
      try {
        console.log("Fetching reference offers...", rowSelected);
        const body = {
          //target: "listBuyerExtendedItems",
          target: "listBuyerItemRFQDetails",
          userOrder: "CreatedAt ASC",
          rowStart: 0,
          pageSize: 50,
          filterTerms: {
            orGPOOfferStatus: ["Firmoffer", "BAFO"],
            BuyerEmailID: activeUser,
            OfferFor: activeUser,
            ReferenceOffer: rowSelected.GPOfferID,
            RequirementsID: rowSelected.RequirementsID,
          },
        };

        const response = await fetchData(body);
        console.log(response.items);

        if (response.items && response.items.length > 0) {
          // Deduplicate based on GPOfferID to avoid showing same offer multiple times
          const uniqueOffers = response.items.reduce((acc, current) => {
            const existingOffer = acc.find(
              (offer) => offer.GPOfferID === current.GPOfferID
            );
            if (!existingOffer) {
              acc.push(current);
            }
            return acc;
          }, []);

          console.log("Unique offers:", uniqueOffers);
          setReferenceOffers(uniqueOffers);
        }
      } catch (error) {
        console.error("Error fetching requirement details:", error);
        setReferenceOffers([]);
      }
    },
    [activeUser]
  );

  const handleSaveExtendedOffer = async (offer, OfferStatus) => {
    setLoading(true);
    /*  console.log(
      "======================= handleSaveExtendedOffer",
      offer,
      OfferStatus
    );
    return false; */

    try {
      // Simulate API call with a 1-second delay
      let body = null;
      // console.log("Saving data to API:", offer);

      body = {
        target: "buyerShortlistOffer",
        BuyerItemExtendedInput: {
          BuyerItemID: offer.BuyerItemID,
          OfferStatus: OfferStatus,
          Remarks: firmOfferModal.remarks,
          Deleted: 0,
          CategoryType: "rfq",
          GPEmailID: offer.GPEmailID,
          RequirementsID: offer.RequirementsID,
          ReferenceOfferID: offer.ReferenceOfferID || offer.GPOfferID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `${
              OfferStatus === "BAFO"
                ? "BAFO"
                : OfferStatus === "Query"
                ? "Query"
                : "Firm offer"
            } sent successfully!`,
            autoClose: false,
            nextAction: () => {
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: `Failed to send ${
          OfferStatus === "BAFO" ? "BAFO" : "firm offer"
        }. Please try again.`,
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSendffer = (offer, type) => {
    setFirmOfferModal({
      show: true,
      offer: offer,
      remarks: "",
      type: type,
    });
  };

  const handleOfferSubmit = async () => {
    if (firmOfferModal.offer) {
      await handleSaveExtendedOffer(firmOfferModal.offer, firmOfferModal.type);
      setFirmOfferModal({
        show: false,
        offer: null,
        remarks: "",
      });
      await NegotiatedOffers(rowStart);
    }
  };

  const handleFirmOfferCancel = () => {
    setFirmOfferModal({
      show: false,
      offer: null,
      remarks: "",
    });
  };

  const fields = [
    {
      name: "rfqNumber",
      label: "RFQ Number",
      type: "text",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, rfqNumber: value })),
      value: searchValues.rfqNumber,
    },
    {
      name: "deliveryDate",
      label: "Delivery Date",
      type: "date",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, deliveryDate: value })),
      value: searchValues.deliveryDate,
    },
    {
      name: "rfqDate",
      label: "RFQ Date",
      type: "date",
      onChange: (value) =>
        setSearchValues((prev) => ({ ...prev, rfqDate: value })),
      value: searchValues.rfqDate,
    },
  ];

  const handlePageChange = useCallback(
    (page) => {
      const newRowStart = (page - 1) * pageSize;
      setRowStart(newRowStart);
    },
    [pageSize]
  );

  const currentPage = Math.floor(rowStart / pageSize) + 1;
  const formatPrice = (value) => {
    if (!value || value === "") return "0.00";
    const numValue = parseFloat(value);
    return isNaN(numValue) ? "0.00" : numValue.toFixed(2);
  };

  const convertToUSD = (inrValue) => {
    if (!inrValue || inrValue === "") return "0.00";
    const usdValue = parseFloat(inrValue) * INRToUsd;
    return isNaN(usdValue) ? "0.00" : usdValue.toFixed(2);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return dateString;
    }
  };

  const columns = [
    { id: "RequirementNumber", numeric: false, label: "RFQ Number" },
    { id: "ProductName", numeric: false, label: "Product" },
    { id: "Grade", numeric: false, label: "Grade" },
    {
      id: "Quantity",
      numeric: true,
      label: "Quantity (MT)",
      renderCell: (row) => formatPrice(row.Quantity),
    },
    {
      id: "CIFSalePrice",
      numeric: true,
      label: "CIF Sale Price",
      renderCell: (row) => convertToUSD(row.CIFSalePrice),
    },
    { id: "Country", numeric: false, label: "Origin Country" },
    { id: "DestinationCountry", numeric: false, label: "Destination" },
    { id: "INCO", numeric: false, label: "INCO Terms" },
    { id: "OfferType", numeric: false, label: "Offer Type" },
    {
      id: "CreatedAt",
      numeric: false,
      label: "Created Date",
      renderCell: (row) => formatDate(row.CreatedAt),
    },
    {
      id: "Expires",
      numeric: false,
      label: "Expires",
      renderCell: (row) => formatDate(row.Expires),
    },
    {
      id: "KYBStatus",
      numeric: false,
      label: "Seller Status",
      renderCell: (row) => {
        let bgColor = "";
        let textColor = "";

        switch (row.KYBStatus) {
          case "Approved":
            bgColor = "#d1fae5";
            textColor = "#065f46";
            break;
          default:
            bgColor = "#fef3c7";
            textColor = "#b45309";
        }

        return (
          <span
            style={{
              backgroundColor: bgColor,
              color: textColor,
              padding: "4px 10px",
              borderRadius: "999px",
              fontSize: "0.75rem",
              fontWeight: 500,
              display: "inline-block",
            }}
          >
            {row.KYBStatus === "Approved" ? "Verified" : "Unverified"}
          </span>
        );
      },
    },
  ];

  const getBuyerInfo = useCallback(async (buyerEmail) => {
    try {
      const response = await fetchData({
        target: "listAMTPLUsers",
        userOrder: "AMTPLUserID",
        rowStart: 0,
        pageSize: 1,
        filterTerms: { EmailID: buyerEmail },
      });
      setBuyerInfo(response.items || []);
    } catch (error) {
      console.error("Error loading buyer info:", error);
      setBuyerInfo([]);
    }
  }, []);

  const loadAllProducts = useCallback(async () => {
    setLoading(true);
    try {
      const [allProducts] = await Promise.all([
        searchfetchQueries({
          target: "listAllProducts",
          userOrder: "ProductID",
          rowStart: 0,
          pageSize: 1000,
        }),
      ]);
      setAllProductMaster(allProducts);
      const distinctProducts = Array.from(
        new Map(
          allProducts
            .filter((p) => p.productStatus === "ACTIVE") // ✅ Only include active products
            .map((p) => [p.ProductName, p])
        ).values()
      );
      setProductList(distinctProducts);
    } catch (error) {
      console.error("Error loading products: ", error);
      setAllProductMaster([]);
      setProductList([]);
    } finally {
      setLoading(false);
    }
  }, [setLoading]);

  const loadProductGrades = useCallback(
    async (productName) => {
      setLoading(true);
      try {
        const matchingProducts = allProductMaster.filter(
          (p) => p.ProductName === productName
        );
        setProductGradeList(matchingProducts);
      } catch (error) {
        console.error("Error loading product grades: ", error);
      } finally {
        setLoading(false);
      }
    },
    [setLoading, allProductMaster]
  );

  useEffect(() => {
    const checkUser = async () => {
      try {
        const user = await Auth.currentAuthenticatedUser();
        const token = user.signInUserSession.idToken.jwtToken;
        const decodedToken = jwtDecode(token);
        const groups = decodedToken["cognito:groups"] || [];
        if (!groups.includes("AMTPL_BUYERS")) {
          await Auth.signOut();
          navigate("/login/buyer");
        } else {
          setActiveUser(user.attributes.email);
          getBuyerInfo(user.attributes.email);
        }
      } catch (error) {
        console.error("Error checking user:", error);
        await Auth.signOut();
        navigate("/login/buyer");
      }
    };
    checkUser();
  }, [navigate]);

  useEffect(() => {
    if (activeUser) {
      getBuyerInfo(activeUser);
      loadAllProducts();
      NegotiatedOffers();
    }
  }, [
    activeUser,
    getBuyerInfo,
    loadAllProducts,
    NegotiatedOffers,
  ]);

  const handleRowClick = useCallback(
    async (row) => {
      setSelectedOffer(row);
      console.log("row", row);
      getRequirementDetails(row.RequirementsID);
      await getReferenceOffers(row);
    },
    [getRequirementDetails, getReferenceOffers]
  );

  const handleSearch = () => {
    setRowStart(0);
    NegotiatedOffers(0);
  };
  const handleAcceptOffer = useCallback(
    async (refOffer = null) => {
      const offerToAccept = selectedOffer;
      const referenceOffer = refOffer; // Use passed parameter or state

      if (!offerToAccept?.BuyerItemID) {
        console.error("No BuyerItemID found for selected offer");
        return;
      }
      console.log(
        "referenceOfferSelected",
        offerToAccept.BuyerItemExtendedID,
        referenceOffer
      );

      setLoading(true);
      setError(null); // Clear any existing errors
      try {
        const body = {
          target: "buyerExtendedOfferUpdate",
          BuyerItemExtendedInput: {
            OfferStatus: "Accepted",
            BuyerItemExtendedID: offerToAccept.BuyerItemExtendedID,
            ReferenceOfferID: referenceOffer?.GPOfferID,
          },
        };

        console.log("Accepting offer with body:", body);

        const result = await postQuery(body, "backendops");

        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: "Offer accepted successfully!",
            autoClose: false,
            isConfirm: false,
            onConfirm: null,
          });
          // Clear the selected offer
          setSelectedOffer(null);
          setReferenceOfferSelected(null);
          // Reload the table
          await NegotiatedOffers(rowStart);
          console.log("Offer removed successfully");
        }
      } catch (error) {
        console.error("Error removing offer:", error);
        setModal({
          show: true,
          type: "error",
          title: "Error",
          message: "Failed to accept offer. Please try again.",
          autoClose: false,
          isConfirm: false,
          onConfirm: null,
        });
      } finally {
        setLoading(false);
      }
    },
    [
      referenceOfferSelected,
      selectedOffer,
      rowStart,
      NegotiatedOffers,
      setLoading,
    ]
  );

  // Handler for approve button click - shows confirmation dialog
  const handleApprove = useCallback(
    (refOffer = {}) => {
      console.log("refOffer referenceOfferSelected", refOffer);
      setReferenceOfferSelected(refOffer);
      setTimeout(() => {
        setModal({
          show: true,
          type: "warning",
          title: "Confirm Approval",
          message: "Are you sure you want to accept this offer?",
          autoClose: false,
          isConfirm: true,
          onConfirm: () => handleAcceptOffer(refOffer), // Pass refOffer directly to avoid closure issues
        });
      }, 300);
    },
    [handleAcceptOffer]
  );

  /*  const handleRemoveOffer = async () => {
    if (!selectedOffer?.BuyerItemID) {
      console.error("No BuyerItemID found for selected offer");
      return;
    }

    // Confirmation dialog
    if (
      !window.confirm(
        "Are you sure you want to remove this offer from your negotiated list?"
      )
    ) {
      return;
    }

    setLoading(true);
    setError(null); // Clear any existing errors
    try {
      const body = {
        target: "buyerExtendedOfferUpdate",
        BuyerItemExtendedInput: {
          Deleted: 1,
          OfferStatus: "Shortlist",
          BuyerItemExtendedID: selectedOffer.BuyerItemExtendedID,
        },
      };

      const result = await postQuery(body, "backendops");

      if (result) {
        // Clear the selected offer
        setSelectedOffer(null);
        // Reload the table
        await NegotiatedOffers(rowStart);
        console.log("Offer removed successfully");
      }
    } catch (error) {
      console.error("Error removing offer:", error);
      setError("Failed to remove offer. Please try again.");
    } finally {
      setLoading(false);
    }
  }; */

  const handleSendFirmOffer = async (offer) => {
    setLoading(true);

    try {
      // Simulate API call with a 1-second delay
      let body = null;
      // console.log("Saving data to API:", offer);

      body = {
        target: "buyerShortlistOffer",
        BuyerItemExtendedInput: {
          BuyerItemID: offer.BuyerItemID,
          OfferStatus: "Firmoffer",
          Deleted: 0,
          CategoryType: "rfq",
          GPEmailID: offer.GPEmailID,
          RequirementsID: offer.RequirementsID,
        },
      };

      console.log("Saving body to API:", body);
      if (body !== null) {
        const result = await postQuery(body, "backendops");
        console.log("result@", result);
        if (result) {
          setModal({
            show: true,
            type: "success",
            title: "Success",
            message: `Offer sent to firm successfully!`,
            autoClose: false,
            nextAction: () => {
              setSelectedOffer(null);
            },
          });
        }
      }

      // Refresh the table data
    } catch (error) {
      console.error("Error saving data:", error);
      setModal({
        show: true,
        type: "error",
        title: "Error",
        message: "Failed to send firm offer. Please try again.",
        autoClose: false,
      });
    } finally {
      setLoading(false);
    }
  };

  const Button = ({ label, onClick }) => {
    return (
      <button
        className="btn-action-re"
        onClick={onClick}
        style={{ width: "140px" }}
      >
        {label}
      </button>
    );
  };

  // Pass the selectedOffer ID to DataTable via selectedRows
  const selectedRows = selectedOffer
    ? [selectedOffer.GPOfferID || selectedOffer.id]
    : [];

  return (
    <div className="matching-offers-container">
      <AlertModal
        type={modal.type}
        title={modal.title}
        message={modal.message}
        showModal={modal.show}
        onClose={handleModalClose}
        onCancel={handleModalClose}
        buttonText="OK"
        isConfirm={modal.isConfirm}
        onConfirm={modal.onConfirm}
        autoClose={modal.autoClose}
      />
      <div className="table-header">
        <div className="header-text">
          <div className="head-text">Negotiated Offers</div>
        </div>
        <div className="head-btn"></div>
      </div>
      <div className="search-filter row">
        <SearchFilter fields={fields} onSearch={handleSearch} />
      </div>
      {loading && <div className="loading">Loading offers...</div>}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && offerList.length === 0 && (
        <div className="empty-state">No matching offers found.</div>
      )}
      {!loading && offerList.length > 0 && (
        <DataTable
          columns={columns}
          data={offerList}
          total={totalItems}
          title="Matching Offers Information"
          rowsPerPage={pageSize}
          onPageChange={handlePageChange}
          currentPage={currentPage}
          onRowClick={handleRowClick}
          selectedRows={selectedRows} // Pass selected row ID
        />
      )}
      {selectedOffer && (
        <>
          {/* Offer Details Section */}
          <div className="tab-content">
            <Box sx={{ borderBottom: 1, borderColor: "#de6b14" }}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                aria-label="Offer info tabs"
                sx={{
                  "& .MuiTab-root": {
                    color: "#000",
                    backgroundColor: "transparent",
                    "&.Mui-selected": {
                      color: "#fff",
                      backgroundColor: "#de6b14",
                      borderBottom: "2px solid #d4d4d4",
                    },
                  },
                  "& .MuiTabs-indicator": { backgroundColor: "#de6b14" },
                }}
              >
                <Tab
                  label={
                    <div style={{ textAlign: "center" }}>
                      <div>
                        {selectedOffer.OfferNumber}{" "}
                        {selectedOffer.CreatedAt
                          ? `(${formatDate(selectedOffer.CreatedAt)})`
                          : ""}
                      </div>

                      <div style={{ fontSize: "8px", opacity: 0.7 }}>
                        Initial offer
                      </div>
                    </div>
                  }
                  id="tab-0"
                  aria-controls="tabpanel-0"
                />
                {referenceOffers.map((offer, index) => (
                  <Tab
                    key={index}
                    label={
                      <div style={{ textAlign: "center" }}>
                        <div>
                          {referenceOffers[index].OfferNumber}{" "}
                          {referenceOffers[index].CreatedAt
                            ? `(${formatDate(
                                referenceOffers[index].CreatedAt
                              )})`
                            : ""}
                        </div>
                        <div style={{ fontSize: "8px", opacity: 0.7 }}>
                          Offer V{index + 2}
                        </div>
                      </div>
                    }
                    id={`tab-${index + 1}`}
                    aria-controls={`tabpanel-${index + 1}`}
                  />
                ))}
              </Tabs>
            </Box>
            <TabPanel value={tabValue} index={0}>
              <div className="offer-detail1">
                <div className="header-text-re">
                  <div className="head-text">Offer Details</div>
                  <div className="button-group">
                    {/* <Button label="Remove" onClick={handleRemoveOffer} /> */}
                    <Button label="Verification Status" onClick={trustModel} />
                    <Button
                      label="Accept Offer"
                      onClick={() => handleApprove(selectedOffer)}
                    />
                    <Button label="Request a revision" />
                  </div>
                </div>
                {
                  <OfferDetails
                    offer={selectedOffer}
                    btnShortlist={false}
                    btnSendQuery={false}
                    btnRequestQuote={false}
                    btnRequestSpecifications={false}
                    btnRequestBestPrice={false}
                    btnNegotiate={false}
                    btnRequestShippingDetails={false}
                    btnLogisticsSupport={false}
                    btnRaiseQuery={true}
                    breakupTab={true}
                  />
                }
              </div>
            </TabPanel>
            {referenceOffers.map((referenceOffer, index) => (
              <TabPanel key={index} value={tabValue} index={index + 1}>
                <div className="offer-detail1">
                  <div className="header-text-re">
                    <div className="head-text">
                      Reference Offer Details {index + 2}
                    </div>
                    {referenceOffer ? (
                      referenceOffer.BuyerExtendedStatus === "Shortlist" ? (
                        <>
                          <Button label="Verification Status" onClick={trustModel} />
                          <div
                            className="shortlist-text"
                            style={{
                              background: "#de6b14",
                              color: "#fff",
                              borderRadius: "6px",
                              padding: "4px 14px",
                              display: "inline-block",
                            }}
                          >
                            Shortlisted
                          </div>
                        </>
                      ) : referenceOffer.BuyerExtendedStatus === "Firmoffer" ? (
                        <>
                          <Button label="Verification Status" onClick={trustModel} />
                          <div
                            className="shortlist-text"
                            style={{
                              background: "#de6b14",
                              color: "#fff",
                              borderRadius: "6px",
                              padding: "4px 14px",
                              display: "inline-block",
                              width: "125px",
                              textAlign: "center",
                            }}
                          >
                            Send Firm Offer
                          </div>
                        </>
                      ) : referenceOffer.BuyerExtendedStatus === "BAFO" ? (
                        <>
                          <Button label="Verification Status" onClick={trustModel} />
                          <div
                            className="shortlist-text"
                            style={{
                              background: "#de6b14",
                              color: "#fff",
                              borderRadius: "6px",
                              padding: "4px 14px",
                              display: "inline-block",
                              width: "125px",
                              textAlign: "center",
                            }}
                          >
                            BAFO
                          </div>
                        </>
                      ) : referenceOffer.BuyerExtendedStatus === "Query" ? (
                        <>
                          <Button label="Verification Status" onClick={trustModel} />
                          <div
                            className="shortlist-text"
                            style={{
                              background: "#de6b14",
                              color: "#fff",
                              borderRadius: "6px",
                              padding: "4px 14px",
                              display: "inline-block",
                              width: "125px",
                              textAlign: "center",
                            }}
                          >
                            Query Sent
                          </div>
                        </>
                      ) : referenceOffer.BuyerExtendedStatus === "Accepted" ? (
                        <>
                          <Button label="Verification Status" onClick={trustModel} />
                          <div
                            className="shortlist-text"
                            style={{
                              background: "#de6b14",
                              color: "#fff",
                              borderRadius: "6px",
                              padding: "4px 14px",
                              display: "inline-block",
                              width: "125px",
                              textAlign: "center",
                            }}
                          >
                            Accepted
                          </div>
                        </>
                      ) : (
                        <div className="button-group">
                          <Button label="Verification Status" onClick={trustModel} />
                          <Button
                            label="Accept Offer"
                            onClick={() => handleApprove(referenceOffer)}
                          />
                          <Button
                            label="Send BAFO"
                            onClick={() =>
                              handleSendffer(referenceOffer, "BAFO")
                            }
                          />
                          {referenceOffer.BuyerExtendedStatus !==
                            "Firmoffer" && (
                            <Button
                              label="Send Firm Offer​"
                              onClick={() =>
                                handleSendffer(referenceOffer, "Firmoffer")
                              }
                            />
                          )}

                          {/* 
                    <Button
                      label="Ask seller a question​"
                      onClick={() => handleSendffer(referenceOffer, "Query")}
                    /> */}

                          {/* <Button label="Request a revision" /> */}
                        </div>
                      )
                    ) : (
                      <div></div>
                    )}
                    {/* <div className="button-group">
                      {referenceOffer.BuyerExtendedStatus !== "Firmoffer" && (
                        <Button
                          label="Send Firm Offer​"
                          onClick={() => handleSendFirmOffer(referenceOffer)}
                        />
                      )}
                      <Button
                        label="Accept Offer"
                        onClick={() => handleApprove(referenceOffer)}
                      />
                      <Button label="Request a revision" />
                    </div> */}
                  </div>
                  {
                    <OfferDetails
                      offer={referenceOffer}
                      btnShortlist={false}
                      btnSendQuery={false}
                      btnRequestQuote={false}
                      btnRequestSpecifications={false}
                      btnRequestBestPrice={false}
                      btnNegotiate={false}
                      btnRequestShippingDetails={false}
                      btnLogisticsSupport={false}
                      btnRaiseQuery={true}
                    />
                  }
                </div>
              </TabPanel>
            ))}
          </div>

          {/* RFQ Details Section */}
          {selectedOffer && selectedOffer.RequirementsID && (
            // <RFQDetailsReadOnly
            //   selectedOffer={selectedOffer}
            //   tabValue={rfqDetailsTabValue}
            //   setTabValue={setRfqDetailsTabValue}
            // />
            <RFQForm
              formMode="view"
              setFormMode={true}
              selectedRFQ={selectedRFQ}
              setIsFormVisible={true}
              allProductMaster={allProductMaster}
              btnCancel={false}
              btnHistory={false}
              btnAddFinanceRfq={false}
            />
          )}
        </>
      )}
      {/* Verification Status Modal */}
      {trustModal && selectedOffer && (
        <TrustScoreModal
          onClose={() => setTrustModal(false)}
          userEmail={selectedOffer.SellerEmailID}
        />
      )}
      {/* Firm Offer Modal */}
      {firmOfferModal.show && (
        <div
          className="modal-overlay"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <div
            className="modal-content"
            style={{
              backgroundColor: "white",
              padding: "24px",
              borderRadius: "8px",
              width: "500px",
              maxWidth: "90vw",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
            }}
          >
            <div
              className="modal-header"
              style={{
                marginBottom: "20px",
                borderBottom: "1px solid #e5e7eb",
                paddingBottom: "16px",
              }}
            >
              <h3
                style={{
                  margin: 0,
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#1f2937",
                }}
              >
                {firmOfferModal.type === "BAFO"
                  ? "Send BAFO"
                  : firmOfferModal.type === "Query"
                  ? "Ask seller a question"
                  : "Send Firm Offer"}
              </h3>
            </div>

            <div className="modal-body" style={{ marginBottom: "24px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#374151",
                }}
              >
                Remarks
              </label>
              <textarea
                value={firmOfferModal.remarks}
                onChange={(e) =>
                  setFirmOfferModal((prev) => ({
                    ...prev,
                    remarks: e.target.value,
                  }))
                }
                placeholder="Enter your remarks here..."
                rows={4}
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "1px solid #d1d5db",
                  borderRadius: "6px",
                  fontSize: "14px",
                  resize: "vertical",
                  outline: "none",
                  fontFamily: "inherit",
                }}
              />
            </div>

            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "12px",
              }}
            >
              <button
                onClick={handleFirmOfferCancel}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #d1d5db",
                  backgroundColor: "white",
                  color: "#374151",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "14px",
                }}
              >
                Cancel
              </button>
              <button onClick={handleOfferSubmit} className="submit-btn-more">
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default NegotiateOffers;
